document.addEventListener('DOMContentLoaded', function() {
    var toggleButton = document.querySelector('.js-toggle-subnav');
    var subnav = document.querySelector('.subnav');

    if ( subnav ) {
        toggleButton.addEventListener('click', function() {
            toggleButton.classList.toggle('is-active');
            subnav.classList.toggle('is-active');
        });
    }
    
});